import React from 'react';
import Container from "react-bootstrap/Container";
const Resources = () => <Container id="MEDCAL_RX_RESOURCES_PAGE"><h1 id="MEDCAL_RX_RESOURCES_HEADER">Resources</h1></Container>;
export default Resources;
